/**
 * Points du devineur, decroissant en temps reel.
 *
 * Meme principe que TimerRing : la valeur est ecrite directement dans le DOM
 * par une boucle rAF, jamais via setState.
 */
import { useEffect, useRef, type ReactElement } from 'react';
import { DEFAULT_GUESS_TIME_MS, GUESSER_MAX_SCORE, scoreGuesser } from '@retusch/shared';

export interface LiveScoreProps {
  /** Horodatage performance.now() du debut de la phase. */
  readonly startedAt: number;
  /** Fige l'affichage (clic joue, timeout). */
  readonly frozen: boolean;
  /** Duree de la phase, en ms : la decroissance doit epouser le reglage. */
  readonly guessTimeMs?: number;
}

export function LiveScore({
  startedAt,
  frozen,
  guessTimeMs = DEFAULT_GUESS_TIME_MS,
}: LiveScoreProps): ReactElement {
  const ref = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    if (frozen) return;

    let raf = 0;
    let last = -1;
    const frame = (now: number): void => {
      const score = scoreGuesser({ found: true, elapsedMs: now - startedAt, guessTimeMs });
      if (score !== last && ref.current !== null) {
        ref.current.textContent = String(score);
        last = score;
      }
      raf = requestAnimationFrame(frame);
    };
    raf = requestAnimationFrame(frame);
    return () => cancelAnimationFrame(raf);
  }, [startedAt, frozen, guessTimeMs]);

  return (
    <span className="board__score" ref={ref}>
      {GUESSER_MAX_SCORE}
    </span>
  );
}
